import React, { useState, useEffect, useRef, useCallback, forwardRef, useImperativeHandle } from 'react';
import useIframeEnterKey from './useIframeEnterKey';
import { useNavigate } from 'react-router-dom';
import back_n from "../Tutorials/Image/back_n.gif";
import back_o from "../Tutorials/Image/back_o.gif";
import back_d from "../Tutorials/Image/back_d.gif";
import principle_n from "../Tutorials/Image/principle_n.gif";
import tutorials_n from "../Tutorials/Image/tutorials_n.gif";
import clue_n from "../Tutorials/Image/clue_n.gif";
import solution_n from "../Tutorials/Image/solution_n.gif";
import solution_o from "../Tutorials/Image/solution_o.gif";
import solution_d from "../Tutorials/Image/solution_d.gif";
import next_n from "../Tutorials/Image/next_n.gif";
import next_o from "../Tutorials/Image/next_o.gif";
import next_d from "../Tutorials/Image/next_d.gif";
import ok_n from "../Tutorials/Image/ok_n.gif";
import ok_o from "../Tutorials/Image/ok_o.gif";
import ok_d from "../Tutorials/Image/ok_d.gif";
import x_close_btn_n from "../Tutorials/Image/x_close_btn_n.png";
import x_close_btn_o from "../Tutorials/Image/x_close_btn_o.png";
import next_step_btn_n from "../Tutorials/Image/next_step_btn_n.png";
import next_step_btn_o from "../Tutorials/Image/next_step_btn_o.png";
import got_it_btn_n from "../Tutorials/Image/got_it_btn_n.png";
import got_it_btn_o from "../Tutorials/Image/got_it_btn_o.png";
import done_o from "../Tutorials/Image/done_o.gif";
import done_n from "../Tutorials/Image/done_n.gif";
import './Style/Question.css';
import Loading from "../../Common/Loading";
import { buildNextQuestionData, buildShuffledQuestionsOrder, saveQuestionPerformance, QuestionPerformancePayload } from '../../services/questionApi';
import { useViewLessonPreview } from './hooks/useViewLessonPreview';

export interface AnswerRef {
  getAnswer: () => {
    marks: number;
    noOfOptions: number;
    enteredCorrectAnswer: string;
    enteredWrongAnswer: string;
    enteredBlankAnswer: string;
    scoringMethod?: number | null;
    optOrder?: string;
  } | null;
}

interface WQnsProps {
  lessonMeta?: any;
  questionHtml: string;
  currentPage: number;
  totalPages: number;
  goToNextPage?: (e: React.MouseEvent) => void;
  showAlert: (message: string) => void;
  correctAudio: string[];
  incorrectAudio: string[];
  assetsBaseUrl?: string;
  sessionId: number | null;
  isCompleting?: boolean;
  updateSessionPoints?: (pointsEarned: number) => void;
  hwid?: number | null;
  subject?: string;
  previewMode?: string | null;
}

const WQns: React.ForwardRefRenderFunction<AnswerRef, WQnsProps> = (props, ref) => {
  const { lessonMeta, questionHtml, currentPage, totalPages, showAlert, goToNextPage, correctAudio, incorrectAudio, assetsBaseUrl, sessionId, isCompleting, updateSessionPoints, hwid, subject, previewMode } = props;
  const navigate = useNavigate();
  const iframeRef = useRef<HTMLIFrameElement | null>(null);
  const solnIframeRef = useRef<HTMLIFrameElement>(null);

  const [backSrc, setBackSrc] = useState(back_n);
  const [nextSrc, setNextSrc] = useState(next_n);
  const [okSrc, setOkSrc] = useState(ok_n);
  const [solutionSrc, setSolutionSrc] = useState(solution_n);
  const [CloseBtnSrc, setCloseBtnSrc] = useState(x_close_btn_n);
  const [NextStepBtnSrc, setNextStepBtnSrc] = useState(next_step_btn_n);
  const [GotItBtnSrc, setGotItBtnSrc] = useState(got_it_btn_n);
  const [okClicked, setOkClicked] = useState(false);
  const [currentQnMeta, setCurrentQnMeta] = useState<any | null>(null);
  const [showClueModal, setShowClueModal] = useState(false);
  const [clueContent,
    setClueContent
  ] = useState('');
  const [isClueLoading, setIsClueLoading] = useState(false);
  const [noOfClues, setNoOfClues] = useState(0);
  const [clueSeen, setClueSeen] = useState(false);
  const clueIframeRef = useRef<HTMLIFrameElement>(null);
  const prcIframeRef = useRef<HTMLIFrameElement>(null);
  const [showPrcModal, setShowPrcModal] = useState(false);
  const [prcContent,
    setPrcContent
  ] = useState("");
  const [prcSeen, setPrcSeen] = useState(false);
  const [principleList, setPrincipleList] = useState<string[]>([]);
  const [currentPrcIndex, setCurrentPrcIndex] = useState(0);
  const [currentClueNo, setCurrentClueNo] = useState(0);
  const [isPrcLoading, setIsPrcLoading] = useState(false);
  const [showSolnModal, setShowSolnModal] = useState(false);
  const [isSolnLoading, setIsSolnLoading] = useState(false);
  const [solnContent, setSolnContent] = useState("");
  const [solutionSeen, setSolutionSeen] = useState<string | number>('N');
  const [currentSolnNo, setCurrentSolnNo] = useState(0);
  const [noOfSteps, setNoOfSteps] = useState(0);
  const [doneSrc, setDoneSrc] = useState(done_n);
  const [isNumberPad, setIsNumberPad] = useState(false);
  const [startTime, setStartTime] = useState<Date | null>(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const search = window.location.search;
  const params = new URLSearchParams(search);
  const folderParam = params.get('folder');
  const lessonName = params.get('name');
  const diccode = params.get('diccode');
  const calledFrom = params.get('calledFrom');
  const isInAssessment = window.location.href.includes('Assessment');

  const handleNextStepBtnMouseOver = () => setNextStepBtnSrc(next_step_btn_o);
  const handleNextStepBtnMouseOut = () => setNextStepBtnSrc(next_step_btn_n);
  const handleGotItBtnMouseOver = () => setGotItBtnSrc(got_it_btn_o);
  const handleGotItBtnMouseOut = () => setGotItBtnSrc(got_it_btn_n);
  const handleBackMouseOver = () => setBackSrc(back_o);
  const handleBackMouseOut = () => setBackSrc(back_n);
  const handleBackMouseDown = () => setBackSrc(back_d);
  const handleBackMouseUp = () => setBackSrc(back_o);
  const handleNextMouseOver = () => setNextSrc(next_o);
  const handleNextMouseOut = () => setNextSrc(next_n);
  const handleNextMouseDown = () => setNextSrc(next_d);
  const handleNextMouseUp = () => setNextSrc(next_o);
  const handleOkMouseOver = () => setOkSrc(ok_o);
  const handleOkMouseOut = () => setOkSrc(ok_n);
  const handleOkMouseDown = () => setOkSrc(ok_d);
  const handleOkMouseUp = () => setOkSrc(ok_o);
  const handleSolutionMouseOver = () => setSolutionSrc(solution_o);
  const handleSolutionMouseOut = () => setSolutionSrc(solution_n);
  const handleSolutionMouseDown = () => setSolutionSrc(solution_d);
  const handleCloseBtnMouseOver = () => setCloseBtnSrc(x_close_btn_o);
  const handleCloseBtnMouseOut = () => setCloseBtnSrc(x_close_btn_n);

  const { isViewLesson, isAnswerMode, isSolutionMode, isPreview, guardSave, handleDoneClick } = useViewLessonPreview(previewMode);

  useEffect(() => {
    if (questionHtml) {
      const hasNumberPad =
        /id=["']KSD_NUMPAD["']/i.test(questionHtml) ||
        /onclick\s*=\s*["'][^"']*insertDigit\s*\(/i.test(questionHtml);

      setIsNumberPad(hasNumberPad);
    } else {
      setIsNumberPad(false);
    }
  }, [questionHtml]);

  const injectSimpleWriteBridge = (html: string) => {
    let cleaned = html
      .replace(/onmousemove="[^"]*"/gi, "")
      .replace(/<script[\s\S]*?<\/script>/gi, "")
      .replace(/(<textarea[^>]*id="(KSD_W|KSD_U)"[^>]*)\s+style="[^"]*"/gi, "$1");

    const styleBridge = `
      <style>
        body { 
          margin: 0 !important; 
          padding: 0 !important; 
          font-family: Verdana, sans-serif !important;
          background-color: #ffffff !important;
        }

        body > table {
          background-color: white !important;
          border: 0 !important;
        }

        #KSD_TABLE {
  width: 100% !important;
  max-width: 950px !important;
  border: 1px solid #d9d9d8 !important;
  background-color: #ffffff !important;
  border-collapse: collapse !important;
  border-spacing: 0 !important;
  margin: 0 auto !important;
}

#KSD_TABLE td {
  border: 1px solid #d9d9d8 !important;
}

        #KSD_TABLE > tbody > tr:first-child > td:first-child {
          background-color: #ed8922 !important;
          color: #ffffff !important;
          padding: 0px 0 !important;
          text-align: center !important;
          font-weight: normal !important;
        }
          

  #KSD_W,
#KSD_U {
  resize: none !important;
  overflow: hidden !important;
  border: 0 !important;
  opacity: 1 !important;
  box-sizing: border-box !important;
  font-family: Verdana !important;
  font-size: 18pt !important;
  color: black !important;
  font-weight: normal !important;
  padding: 15px 0 0 15px !important;
  outline: none !important;
  box-shadow: none !important;
  appearance: none !important;
  -webkit-appearance: none !important;
  width: 100% !important;
  height: 60px !important;
  display: block !important;
  margin: 0 !important;
}
  #KSD_W,
#KSD_U,
#KSD_W:focus,
#KSD_U:focus {
  border: 0 !important;
  outline: none !important;
  box-shadow: none !important;
  appearance: none !important;
  -webkit-appearance: none !important;
}

        #KSD_W_PAD {
          display: none !important;
        }

        #KSD_DIVIDERBAR {
          background-repeat: no-repeat !important;
          background-position: center !important;
        }

        #KSD_TDANS_0, #KSD_TDANS_1, #KSD_TDANSOK {
          vertical-align: middle !important;
          // padding: 5px 0px 0px 15px !important;
          // border-right: 0px solid #fff !important;
        }
        
        p > font > span > font > img, p > span > img {
          vertical-align: middle !important;
        }
      </style>
    `;

    const scriptBridge = `
      <script>
      document.addEventListener('DOMContentLoaded', function() {
        try {
          var box = document.getElementById("KSD_W") || document.getElementById("KSD_U");
          var header = document.querySelector("#KSD_TABLE > tbody > tr > td > b");

          if (header) {
            var text = header.textContent || "";
            text = text.replace("Enter your Answer in the BOX", "Enter your answer in the box");
            header.textContent = text;
          }

          if (box) {
  var initialHeight = box.offsetHeight || 30; 
  box.style.height = (initialHeight + 25) + "px";

  box.style.setProperty("border", "0", "important");
  box.style.setProperty("outline", "none", "important");
  box.style.setProperty("box-shadow", "none", "important");
  box.style.setProperty("appearance", "none", "important");
  box.style.setProperty("-webkit-appearance", "none", "important");

  box.removeAttribute("onkeypress");
  box.focus();

            box.addEventListener("input", function(){
              parent.postMessage({ type: "el-write-answer", value: box.value }, "*");
            });
    
            box.addEventListener("paste", function(e) {
                e.preventDefault();
            });
          }
        } catch(e) { console.error("Bridge error", e); }
      });
      </script>
    `;

    if (cleaned.includes("</head>")) {
      cleaned = cleaned.replace("</head>", styleBridge + "</head>");
    } else {
      cleaned = styleBridge + cleaned;
    }

    if (cleaned.includes("</body>")) {
      cleaned = cleaned.replace("</body>", scriptBridge + "</body>");
    } else {
      cleaned = cleaned + scriptBridge;
    }

    return cleaned;
  }

  // const injectNumberPadWriteBridge = (html: string) => {
  //   let cleaned = html
  //     .replace(/onmousemove="[^"]*"/gi, "")
  //     .replace(/<script[\s\S]*?<\/script>/gi, "")
  //     .replace(/(<textarea[^>]*id="KSD_W"[^>]*)\s+style="[^"]*"/gi, "$1");

  //   const bridge = `
  //     <style>
  //       html, body { height: 100%; margin: 0; padding: 0; }
  //       body { height: 100vh !important; margin: 0; padding: 0; }
  //       body > table:first-of-type { width: 100% !important; height: 100% !important; border-collapse: collapse; }
  //       body > table:first-of-type td {
  //           vertical-align: top;
  //           padding-top: 20px;
  //       }
  //       body, table, td, p, span, div { font-family: Verdana, sans-serif !important; }
  //       textarea#KSD_W, textarea#KSD_U {
  //         resize: none !important; overflow: visible !important; height: 55px !important; font-size: 14pt !important;
  //         font-family: Verdana !important; width: 100% !important; box-sizing: border-box !important;
  //         display: block !important; font-weight: normal !important; opacity: 1 !important; border: 2px solid skyblue !important; margin-top: -20px !important;
  //       }
  //       textarea#KSD_W::-webkit-resizer, textarea#KSD_U::-webkit-resizer,
  //       textarea#KSD_W::-webkit-scrollbar, textarea#KSD_U::-webkit-scrollbar { display: none !important; }
  //       #KSD_NUMPAD img { margin: 0 !important; cursor: pointer !important; }
  //     </style>
  //     <script>
  //       (function(){
  //         try {
  //           var box = document.getElementById("KSD_W") || document.getElementById("KSD_U");
  //           if (box) {
  //             box.addEventListener("input", function(){
  //               box.value = box.value.replace(/[^0-9 \\-+*/().]/g, '');
  //               parent.postMessage({ type: "el-write-answer", value: box.value }, "*");
  //             });
  //           }
  //           window.insertDigit = function(d) {
  //             if (!box) return;
  //             if (d === '←') {
  //               box.value = box.value.slice(0, -1);
  //             } else {
  //               box.value += d;
  //             }
  //             var event = new Event("input", { bubbles: true });
  //             box.dispatchEvent(event);
  //           };
  //         } catch(e) { console.error("Number pad bridge error", e); }
  //       })();
  //     </script>
  //   `;
  //   return cleaned.includes("</body>") ? cleaned.replace("</body>", bridge + "</body>") : cleaned + bridge;
  // }

  const injectNumberPadWriteBridge = (html: string) => {
    let cleaned = html
      .replace(/onmousemove="[^"]*"/gi, "")
      .replace(/<script[\s\S]*?<\/script>/gi, "")
      .replace(/(<textarea[^>]*id="KSD_W"[^>]*)\s+style="[^"]*"/gi, "$1");

    const bridge = `
      <style>
        html, body { height: 100%; margin: 0; padding: 0; }
        body { height: 100vh !important; margin: 0; padding: 0; }
        body > table:first-of-type { width: 100% !important; height: 100% !important; border-collapse: collapse; }
        body > table:first-of-type td {
            vertical-align: top;
        }
        #KSD_TABLE {
          width: 100% !important;
          max-width: 950px !important;
          margin: 0 auto !important;
          border: 1px solid #d9d9d8 !important;
          border-collapse: collapse !important;
          border-spacing: 0 !important;
        }
        #KSD_TABLE td {
          border: 1px solid #d9d9d8 !important;
        }
        #KSD_TABLE > tbody > tr:first-child > td:first-child {
          background-color: #ed8922 !important;
          color: #fff !important;
          padding: 8px 0 !important;
          text-align: center !important;
        }
        #KSD_TDANS_0, #KSD_TDANS_1, #KSD_TDANSOK {
          vertical-align: middle;
        }
        body, table, td, p, span, div { font-family: Verdana, sans-serif !important; }
        table[name="TableQn"] p[align="center"] {
          padding: 0px 0px;
        }
        textarea#KSD_W, textarea#KSD_U {
          resize: none !important; overflow: visible !important; height: 40px !important; font-size: 18pt !important;
          font-family: Verdana !important; width: 100% !important; box-sizing: border-box !important;
          display: block !important; font-weight: normal !important; opacity: 1 !important; border: 1px solid #d9d9d8 !important;
          margin-top: 0px !important; 
          outline: none !important;
        }
        textarea#KSD_W::-webkit-resizer, textarea#KSD_U::-webkit-resizer,
        textarea#KSD_W::-webkit-scrollbar, textarea#KSD_U::-webkit-scrollbar { display: none !important; }
        #KSD_NUMPAD img { margin: 0 !important; cursor: pointer !important; }
      </style>
      <script>
        document.addEventListener('DOMContentLoaded', function() {
          try {

            try {
                const mainLayoutTable = document.querySelector('body > table:first-of-type');
                if (mainLayoutTable) {
                    const tbody = mainLayoutTable.querySelector('tbody');
                    
                    if (tbody && tbody.rows.length > 1) {
                        const questionRow = tbody.rows[0]; // This is the <tr> holding the question <td>
                        const dividerCell = document.getElementById('KSD_DIVIDERBAR');
                        const numpadCell = document.getElementById('KSD_NUMPAD');

                        if (questionRow && dividerCell && numpadCell && dividerCell.closest('tr') !== questionRow && numpadCell.closest('tr') !== questionRow) {
                            const dividerRow = dividerCell.closest('tr');
                            const numpadRow = numpadCell.closest('tr');
                            
                            questionRow.appendChild(dividerCell);
                            questionRow.appendChild(numpadCell);

                            if (dividerRow) dividerRow.remove();
                            if (numpadRow) numpadRow.remove();
                        }
                    }
                }
            } catch (e) {
                console.error('Error attempting to fix vertical layout:', e);
            }

            try {
              const firstTd = document.querySelector('body > table:first-of-type > tbody > tr:first-child > td:first-child');
              if (firstTd) {
                firstTd.style.padding = '5px';
              }
            
              const dividerBar = document.getElementById('KSD_DIVIDERBAR');
              if (dividerBar) {
                dividerBar.style.paddingLeft = '0px';
                dividerBar.style.paddingTop = '0px';
                dividerBar.style.paddingBottom = '0px';
              }
              
              const numPadCell = document.getElementById('KSD_NUMPAD');
              if (numPadCell) {
                numPadCell.style.padding = '0px';
              }
              
            } catch (e) {
                console.error('Error removing padding from container TDs:', e);
            }

            try {
              const numPadContainer = document.getElementById('KSD_NUMPAD');
              
              if (numPadContainer) {
                const innerTable = numPadContainer.querySelector('table');
                
                if (innerTable) {
                  innerTable.style.margin = '0px';
                  innerTable.style.marginTop = '0px';
                  innerTable.style.borderSpacing = '0px';
                  innerTable.setAttribute('cellpadding', '0'); 

                  if (innerTable.rows.length > 0) {
                    const firstButtonRow = innerTable.rows[0];
                    const numCols = firstButtonRow.cells.length; 
                    const labelRow = innerTable.insertRow(0); 
                    const labelCell = labelRow.insertCell(0);
                    labelCell.textContent = 'Number pad:';
                    labelCell.style.paddingBottom = '10px'; 
                    labelCell.style.fontFamily = 'arial'; 
                    labelCell.style.fontSize = '24pt'; 
                    labelCell.style.color = '#3c5168'; 
                    labelCell.style.fontWeight = 'normal'; 
                    if (numCols > 1) {
                      labelCell.colSpan = numCols;
                    }
                  } else {
                    // console.warn('Inner table for numpad has no rows.');
                  }
                } else {
                  // console.warn('Could not find inner table inside KSD_NUMPAD.');
                }
              } else {
                const numPadButton = document.querySelector('[onclick*="insertDigit"]');
                if (numPadButton) {
                  const innerTable = numPadButton.closest('table');
                  if (innerTable) {
                    innerTable.style.margin = '0px';
                    innerTable.style.marginTop = '0px';
                    innerTable.style.borderSpacing = '0px';
                    innerTable.setAttribute('cellpadding', '0');
                    if (innerTable.rows.length > 0) {
                      const firstButtonRow = innerTable.rows[0];
                      const numCols = firstButtonRow.cells.length;
                      const labelRow = innerTable.insertRow(0);
                      const labelCell = labelRow.insertCell(0);
                      labelCell.textContent = 'Number pad:';
                      labelCell.style.textAlign = 'left';
                      labelCell.style.paddingBottom = '10px';
                      labelCell.style.fontFamily = 'arial';
                      labelCell.style.fontSize = '24pt';
                      labelCell.style.color = '#3c5168';
                      labelCell.style.fontWeight = 'normal';
                      if (numCols > 1) {
                        labelCell.colSpan = numCols;
                      }
                    }
                  }
                } else {
                  // console.warn('KSD_NUMPAD element and numpad buttons not found.');
                }
              }
            } catch (e) {
              console.error('Error adding number pad label:', e);
            }

            var box = document.getElementById("KSD_W") || document.getElementById("KSD_U");
            if (box) {
              box.focus();
              box.addEventListener("input", function(){
                box.value = box.value.replace(/[^0-9 \\-+*/().]/g, '');
                parent.postMessage({ type: "el-write-answer", value: box.value }, "*");
              });
            }
            window.insertDigit = function(d) {
              if (!box) return;
              if (d === '←') {
                box.value = box.value.slice(0, -1);
              } else {
                box.value += d;
              }
              var event = new Event("input", { bubbles: true });
              box.dispatchEvent(event);
            };

          } catch(e) { console.error("Number Pad Bridge Error:", e); }
        });
      </script>
    `;
    return cleaned.includes("</body>") ? cleaned.replace("</body>", bridge + "</body>") : cleaned + bridge;
  }

  useEffect(() => {
    const iframe = iframeRef.current;
    if (iframe && questionHtml) {
      iframe.srcdoc = isNumberPad ? injectNumberPadWriteBridge(questionHtml) : injectSimpleWriteBridge(questionHtml);
    }
  }, [questionHtml, isNumberPad]);

  useEffect(() => {
    if (lessonMeta && Array.isArray(lessonMeta.qns) && currentPage <= lessonMeta.qns.length) {
      setCurrentQnMeta(lessonMeta.qns[currentPage - 1]);
    } else {
      setCurrentQnMeta(null);
    }
    setOkClicked(false);
    setStartTime(new Date());
    setSolutionSeen('N');
    setPrcSeen(false);
    setClueSeen(false);
  }, [currentPage, lessonMeta]);

  useImperativeHandle(ref, () => ({
    getAnswer: () => {
      const iframeDoc = iframeRef.current?.contentDocument;
      if (!iframeDoc) return null;

      const userAnswerEl = iframeDoc.querySelector("#KSD_W") as HTMLTextAreaElement | null;
      const userAnswer = userAnswerEl?.value.trim() ?? "";

      if (!userAnswer) {
        showAlert("Please answer your answer");
        return null;
      }

      const correctAnswerEl = iframeDoc.querySelector("#KSD_MW_CA") as HTMLInputElement | null;
      const correctAnswer = correctAnswerEl?.value.trim() || "";

      let isCorrect = false;
      const normalize = (str: string) => str.replace(/[\s\xa0]+/g, ' ').trim();

      try {
        if (isNumberPad) {
          const userAnswerEval = new Function('return ' + userAnswer)();
          const correctAnswerEval = new Function('return ' + correctAnswer)();
          isCorrect = userAnswerEval === correctAnswerEval;
        } else {
          const userAns = normalize(userAnswer).toLowerCase();
          const correctAnswers = correctAnswer
            .split('|')
            .map(ans => normalize(ans).toLowerCase());

          isCorrect = correctAnswers.includes(userAns);
        }
      } catch (error) {
        const userAns = normalize(userAnswer).toLowerCase();
        const correctAnswers = correctAnswer
          .split('|')
          .map(ans => normalize(ans).toLowerCase());
        isCorrect = correctAnswers.includes(userAns);
      }
      const marks = isCorrect ? 1 : 0;

      return {
        marks,
        noOfOptions: 1,
        enteredCorrectAnswer: isCorrect ? userAnswer : "",
        enteredWrongAnswer: !isCorrect ? userAnswer : "",
        enteredBlankAnswer: "",
        optOrder: "",
        scoringMethod: null
      };
    }
  }));

  const handleClueClick = useCallback(async () => {
    // console.log("handleClueClick triggered!");
    if (!currentQnMeta || !lessonMeta) return;

    setShowClueModal(true);
    setIsClueLoading(true);
    setClueContent("");
    setCurrentClueNo(0);
    setNoOfClues(0);

    const searchParams = new URLSearchParams(window.location.search);
    const folderParam = searchParams.get('folder');
    const countryParam = params.get('country') || 'Australia';
    const varValuesParam = currentQnMeta.VarValues || "";

    if (!folderParam) {
      showAlert("Could not determine the lesson folder.");
      setIsClueLoading(false);
      setShowClueModal(false);
      return;
    }

    const accessToken = localStorage.getItem('access_token');
    const headers: HeadersInit = { 'Content-Type': 'application/json' };
    if (accessToken) {
      headers['Authorization'] = `Bearer ${accessToken}`;
    } else {
      console.warn("Access token not found in localStorage.");
    }

    const apiUrl = process.env.REACT_APP_DOCUMENT_LINK;

    try {
      const response = await fetch(`${apiUrl}clue/`, {
        method: 'POST',
        headers: headers,
        body: JSON.stringify({
          folder: folderParam,
          questionNo: currentQnMeta.QnNo,
          country: countryParam,
          varValues: varValuesParam,
        }),
      });

      if (!response.ok) {
        if (response.status === 404) {
          setClueContent("");
        } else {
          if (response.status === 401 || response.status === 403) {
            showAlert("Authentication failed. Please log in again.");
          }
          throw new Error(`HTTP error! status: ${response.status}`);
        }
      } else {
        const data = await response.json();
        setClueContent(data.clueHtml || "");
        setClueSeen(true); // Mark clue as seen
      }

    } catch (error) {
      console.error("Error fetching clue:", error);
      if (!(error instanceof Error && (error.message.includes("status: 401") || error.message.includes("status: 403") || error.message.includes("status: 404")))) {
        showAlert("Failed to load the clue. Please try again.");
      }
      setClueContent("");
    } finally {
      setIsClueLoading(false);
    }
  }, [currentQnMeta, lessonMeta, showAlert, params]); // Added params dependency


  const fetchPrincipleContent = async (principleId: string, folderParam: string, countryParam: string) => {
    const accessToken = localStorage.getItem('access_token');
    const headers: HeadersInit = { 'Content-Type': 'application/json' };
    if (accessToken) headers['Authorization'] = `Bearer ${accessToken}`;

    const apiUrl = process.env.REACT_APP_DOCUMENT_LINK;

    const response = await fetch(`${apiUrl}principle/`, {
      method: 'POST',
      headers: headers,
      body: JSON.stringify({
        folder: folderParam,
        questionNo: principleId,
        country: countryParam,
      }),
    });

    if (!response.ok) throw new Error("Failed");
    return await response.json();
  };

  const handlePrcClick = useCallback(async () => {
    if (!currentQnMeta || !lessonMeta) return;

    const prcString = currentQnMeta.PrincipleNos || "";
    const prcIds = prcString.replace(/"/g, "").split(',').filter((s: string) => s.trim() !== "");

    if (prcIds.length === 0) {
      if ((currentQnMeta.NoOfPrc || 0) > 0) {
        prcIds.push("1");
      } else {
        showAlert("No principles found for this question.");
        return;
      }
    }

    setShowPrcModal(true);
    setIsPrcLoading(true);
    setPrcContent("");
    setPrincipleList(prcIds);
    setCurrentPrcIndex(0);

    const searchParams = new URLSearchParams(window.location.search);
    const folderParam = searchParams.get('folder');
    const countryParam = params.get('country') || 'Australia';

    if (!folderParam) {
      showAlert("Could not determine the lesson folder.");
      setIsPrcLoading(false);
      setShowPrcModal(false);
      return;
    }

    try {
      const data = await fetchPrincipleContent(prcIds[0], folderParam, countryParam);
      setPrcContent(data.principleHtml || "");
      setPrcSeen(true);
    } catch (error) {
      console.error("Error fetching principle:", error);
      setPrcContent("");
    } finally {
      setIsPrcLoading(false);
    }
  }, [currentQnMeta, lessonMeta, showAlert, params]);

  const handleSolnClick = useCallback(async (autoExpand = false) => {
    if (!currentQnMeta || !lessonMeta) return;

    setShowSolnModal(true);
    setIsSolnLoading(true);
    setSolnContent("");
    setCurrentSolnNo(0);
    setNoOfSteps(0);

    const searchParams = new URLSearchParams(window.location.search);
    const folderParam = searchParams.get('folder');
    const countryParam = params.get('country') || 'Australia';

    if (!folderParam) {
      showAlert("Could not determine the lesson folder.");
      setIsSolnLoading(false);
      setShowSolnModal(false);
      return;
    }

    const accessToken = localStorage.getItem('access_token');
    const headers: HeadersInit = { 'Content-Type': 'application/json' };
    if (accessToken) {
      headers['Authorization'] = `Bearer ${accessToken}`;
    } else {
      console.warn("Access token not found in localStorage.");
    }

    const apiUrl = process.env.REACT_APP_DOCUMENT_LINK;

    try {
      const response = await fetch(`${apiUrl}solution/`, {
        method: 'POST',
        headers: headers,
        body: JSON.stringify({
          folder: folderParam,
          questionNo: currentQnMeta.QnNo,
          country: countryParam,
          autoExpand: autoExpand,
        }),
      });

      if (!response.ok) {
        if (response.status === 401 || response.status === 403) {
          showAlert("Authentication failed. Please log in again.");
        }
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      setSolnContent(data.solutionHtml || "");
      if (solutionSeen === 'N') {
        setSolutionSeen(1);
      }

    } catch (error) {
      console.error("Error fetching solution:", error);
      if (!(error instanceof Error && (error.message.includes("status: 401") || error.message.includes("status: 403")))) {
        showAlert("Failed to load the solution. Please try again.");
      }
      setShowSolnModal(false);
    } finally {
      setIsSolnLoading(false);
    }
  }, [currentQnMeta, lessonMeta, showAlert, solutionSeen]);

  const playRandomSound = useCallback(async (soundFiles: string[], folder: 'Correct' | 'Incorrect') => {
    const baseUrl = assetsBaseUrl || "https://www.elearnoncloud.com/Storage/assets/";
    if (!soundFiles || soundFiles.length === 0) return;
    const fileName = soundFiles[Math.floor(Math.random() * soundFiles.length)];
    const audioUrl = `${baseUrl}Audio/Question/${folder}/${fileName}`;
    const audio = new Audio(audioUrl);
    try { await audio.play(); } catch (error) { console.error(`Error playing audio from ${audioUrl}:`, error); }
  }, [assetsBaseUrl]);

  const handleDbUpdate = useCallback(guardSave((payload: QuestionPerformancePayload) => {
    return saveQuestionPerformance(payload)
      .then((data) => { if (isCompleting && updateSessionPoints) updateSessionPoints(data.pointsEarned || 0); return data; })
      .catch((error) => { console.error("Save Performance Error:", error); throw error; });
  }), [isCompleting, updateSessionPoints, guardSave]);

  const handleOkClick = useCallback(async (e: React.MouseEvent<any>) => {
    e.preventDefault();
    if (okClicked || isSubmitting) return;

    const iframe = iframeRef.current;
    const isCompleting = currentPage === totalPages;
    if (!iframe?.contentDocument) return;
    const iframeDoc = iframe.contentDocument;

    const userAnswerEl = iframeDoc.querySelector("#KSD_W") as HTMLTextAreaElement | null;
    const userAnswer = userAnswerEl?.value.trim() ?? "";

    if (!userAnswer) {
      showAlert("Please answer the question");
      return;
    }

    const correctAnswerEl = iframeDoc.querySelector("#KSD_MW_CA") as HTMLInputElement | null;
    const correctAnswer = correctAnswerEl?.value.trim() || "";

    let isCorrect = false;
    const normalize = (str: string) => str.replace(/[\s\xa0]+/g, ' ').trim();

    try {
      if (isNumberPad) {
        const userAnswerEval = new Function('return ' + userAnswer)();
        const correctAnswerEval = new Function('return ' + correctAnswer)();
        isCorrect = userAnswerEval === correctAnswerEval;
      } else {
        const userAns = normalize(userAnswer).toLowerCase();
        const correctAnswers = correctAnswer
          .split('|')
          .map(ans => normalize(ans).toLowerCase());

        isCorrect = correctAnswers.includes(userAns);
      }
    } catch (error) {
      const userAns = normalize(userAnswer).toLowerCase();
      const correctAnswers = correctAnswer
        .split('|')
        .map(ans => normalize(ans).toLowerCase());
      isCorrect = correctAnswers.includes(userAns);
    }
    const marks = isCorrect ? 1 : 0;

    const questionAnswerTime = startTime ? Math.floor((new Date().getTime() - startTime.getTime()) / 1000) : 0;
    const schoolCode = sessionStorage.getItem('SchoolCode') || '';
    const familyCode = sessionStorage.getItem('FamilyCode') || '';
    const login = sessionStorage.getItem('Login') || '';
    const chapterCode = sessionStorage.getItem('ChapterCode') || '';
    const unitCode = sessionStorage.getItem('UnitCode') || '';

    // Logic to determine if this is the final submit
    const isLastQuestion = currentPage === totalPages;

    const payload: QuestionPerformancePayload = {
      schoolCode,
      familyCode,
      login,
      dicCode: sessionStorage.getItem('SelectedDICFile') || '',
      lsnTestCode: sessionStorage.getItem('LsnTestCode') || '',
      sessionId: sessionId || 1,
      qnNo: currentQnMeta?.QnNo,
      subNo: 0,
      qnType: currentQnMeta?.QnType,
      marks: marks,
      noOfOptions: 1,
      enteredCorrectAnswer: isCorrect ? userAnswer : "",
      enteredWrongAnswer: !isCorrect ? userAnswer : "",
      enteredBlankAnswer: "",
      solutionSeen: (typeof solutionSeen === 'number' && solutionSeen > 0) || solutionSeen === 'Y' ? 'Y' : 'N',
      clueSeen: clueSeen,
      principleSeen: prcSeen,
      questionLoadTime: 0,
      questionAnswerTime: questionAnswerTime,
      lastQnInd: currentQnMeta?.LastQnInd || currentPage,
      nextQnData: buildNextQuestionData(lessonMeta?.qns, currentPage),
      dbgShuffledQnsOrder: buildShuffledQuestionsOrder(lessonMeta?.qns),
      allQuestionsCompleted: isCompleting ? 'True' : 'False',
      chapterCode: chapterCode,
      unitCode: unitCode,
      hwid: hwid,
      subject: subject
    };

    // --- NEW ASYNC LOGIC START ---
    if (isLastQuestion) {
      setIsSubmitting(true);
      try {
        await handleDbUpdate(payload);
      } catch (e) {
        console.error("Final submit failed", e);
        showAlert("Error saving progress. Please try again.");
        setIsSubmitting(false);
        return;
      }
      setIsSubmitting(false);
    } else {
      // Fire and forget for intermediate questions
      handleDbUpdate(payload).catch(e => console.error("Background save failed", e));
    }
    // --- NEW ASYNC LOGIC END ---

    const answerTable = iframeDoc.getElementById("KSD_TABLE") as HTMLElement | null;
    // if (answerTable) {
    if (answerTable) {
      answerTable.style.setProperty("width", "100%", "important");
      answerTable.style.setProperty("max-width", "950px", "important");
      answerTable.style.setProperty("margin", "0 auto", "important");
      answerTable.style.setProperty("border", "1px solid #d9d9d8", "important");
      answerTable.style.setProperty("border-collapse", "collapse", "important");
      answerTable.querySelectorAll("tr").forEach(row => {
        row.querySelectorAll("td").forEach(cell => {
          const element = cell as HTMLElement;
          element.style.setProperty("border", "1px solid #d9d9d8", "important");
          element.style.setProperty("padding", "5px 15px", "important");
          element.style.setProperty("border-left", "0", "important");
        });
      });
      answerTable.querySelectorAll('[id^="KSD_TDANS_"], [id^="TDANS_"]').forEach(cell => {
        const element = cell as HTMLElement;
        element.style.setProperty("border-left", "0", "important");
        element.style.setProperty("border-right", "0", "important");
      });
      const answerCell = answerTable.querySelector('td:has(#KSD_W), td:has(#KSD_U)') as HTMLElement | null;
      if (answerCell) {
        answerCell.style.setProperty("border-left", "0", "important");
      }
    }
    if (userAnswerEl) {
      userAnswerEl.style.padding = "5px 0 0 0";
      userAnswerEl.style.boxSizing = "border-box";

      userAnswerEl.style.setProperty("border", "0", "important");
      userAnswerEl.style.setProperty("outline", "none", "important");
      userAnswerEl.style.setProperty("box-shadow", "none", "important");
    }

    const CORRECT_URL = "https://www.elearnoncloud.com/Storage/assets/Image/Questions/EL_O/AnsCorrect.GIF";
    const WRONG_URL = "https://www.elearnoncloud.com/Storage/assets/Image/Questions/EL_O/AnsWrong.GIF";
    const AnsShouldbe_URL = "https://www.elearnoncloud.com/Storage/assets/Image/Questions/EL_O/AnsShouldbe.GIF";

    if (!isNumberPad && userAnswerEl) {

      userAnswerEl.disabled = true;

      const tdAns0 = iframeDoc.getElementById("KSD_TDANS_0");
      const tdAns1 = iframeDoc.getElementById("KSD_TDANS_1");
      const tdAnsOk = iframeDoc.getElementById("KSD_TDANSOK");
      const answerRow = userAnswerEl.closest("tr");
      const answerCell = userAnswerEl.closest("td");

      // The no-pad feedback is displayed as two result rows. Replace the
      // editable textarea cell with the submitted text after validation.
      if (answerCell) {
        answerCell.textContent = userAnswer;
        answerCell.style.display = "table-cell";
        answerCell.style.setProperty("background-color", "#ffffff", "important");
        answerCell.style.color = "#000000";
        answerCell.style.font = "18pt Arial, sans-serif";
        answerCell.style.padding = "10px 15px";
        answerCell.style.width = "92%";
      }
      if (answerRow) {
        answerRow.style.setProperty("background-color", "#ffffff", "important");
        answerRow.querySelectorAll("td").forEach(cell => {
          (cell as HTMLElement).style.setProperty("background-color", "#ffffff", "important");
        });
      }

      if (tdAns0) tdAns0.innerHTML = "";
      if (tdAns1) tdAns1.innerHTML = "";
      if (tdAnsOk) tdAnsOk.innerHTML = "";

      if (isCorrect) {
        if (tdAns0) {
          tdAns0.style.display = "";
          tdAns0.innerHTML = `<img id='imgR' src='${CORRECT_URL}' alt='Correct Answer' style='vertical-align: middle;'/>`;
        }
        if (tdAns1) tdAns1.style.display = "none";
        if (tdAnsOk) tdAnsOk.style.display = "none";
        playRandomSound(correctAudio, 'Correct');
      } else {
        if (tdAns0) {
          tdAns0.style.display = "";
          tdAns0.innerHTML = `<img id='imgR' src='${WRONG_URL}' alt='Incorrect Answer' style='vertical-align: middle;'/>`;
        }

        if (tdAns1) {
          tdAns1.style.display = "";
          tdAns1.innerHTML = `<img id='imgR' src='${AnsShouldbe_URL}' alt='Correct Answer' style='vertical-align: middle;'/>`;
        }

        if (tdAnsOk) {
          tdAnsOk.style.display = "";
          tdAnsOk.style.fontFamily = "Verdana";
          tdAnsOk.style.color = "green";
          tdAnsOk.style.fontSize = "15pt";
          tdAnsOk.style.fontWeight = "normal";

          const displayAnswer = correctAnswer.split('^^')[0] || correctAnswer;
          tdAnsOk.innerHTML = displayAnswer;
          tdAnsOk.style.setProperty("background-color", "#ffffff", "important");
          tdAnsOk.style.padding = "10px 15px";
          tdAnsOk.style.width = "92%";
        }

        if (tdAns0) {
          tdAns0.style.width = "8%";
          tdAns0.style.padding = "5px 10px";
          tdAns0.style.setProperty("background-color", "#ffffff", "important");
        }
        if (tdAns1) {
          tdAns1.style.width = "8%";
          tdAns1.style.padding = "5px 10px";
          tdAns1.style.setProperty("background-color", "#ffffff", "important");
        }

        playRandomSound(incorrectAudio, 'Incorrect');

        if (currentQnMeta?.NoOfSol && currentQnMeta.NoOfSol > 0) {
          handleSolnClick(true);
        }
      }

    } else {
      const tdAns0 = iframeDoc.querySelector("#KSD_TDANS_0") as HTMLElement | null;
      const tdAns1 = iframeDoc.querySelector("#KSD_TDANS_1") as HTMLElement | null;
      const tdAnsOk = iframeDoc.querySelector("#KSD_TDANSOK") as HTMLElement | null;

      if (tdAns0) tdAns0.innerHTML = "";
      if (tdAns1) tdAns1.innerHTML = "";
      if (tdAnsOk) tdAnsOk.innerHTML = "";

      if (isCorrect) {
        if (tdAns0) {
          tdAns0.innerHTML = `<img data-mark="1" src="${CORRECT_URL}" alt="Correct">`;
          tdAns0.style.display = "table-cell";
        }
        if (tdAns1) {
          tdAns1.innerHTML = "";
          tdAns1.style.display = "none";
        }
        if (tdAnsOk) {
          tdAnsOk.innerHTML = "";
          tdAnsOk.style.display = "none";
        }

        playRandomSound(correctAudio, 'Correct');
      } else {
        if (tdAns0) {
          tdAns0.innerHTML = `<img data-mark="1" src="${WRONG_URL}" alt="Incorrect">`;
          tdAns0.style.display = "table-cell";
        }
        if (tdAns1) {
          tdAns1.innerHTML = `<img data-mark="1" src="${AnsShouldbe_URL}" alt="Answer should be">`;
          tdAns1.style.display = "table-cell";
        }
        if (tdAnsOk) {
          tdAnsOk.innerHTML = `<span style="font-size: 15pt;font-weight: normal;color: rgb(0, 128, 0);font-family: Verdana;">${correctAnswer}</span>`;
          tdAnsOk.style.display = "table-cell";
        }
        playRandomSound(incorrectAudio, 'Incorrect');

        if (currentQnMeta?.NoOfSol && currentQnMeta.NoOfSol > 0) {
          handleSolnClick(true);
        }
      }

      if (iframe?.contentWindow) {
        (iframe.contentWindow as any).insertDigit = () => { };
      }
    }

    setOkClicked(true);
  }, [
    iframeRef, okClicked, isSubmitting, currentPage, totalPages, isNumberPad,
    startTime, sessionId, currentQnMeta, solutionSeen, clueSeen, prcSeen,
    updateSessionPoints, showAlert, correctAudio, incorrectAudio, playRandomSound,
    handleSolnClick, handleDbUpdate, hwid, subject
  ]);

  useEffect(() => {
    const listener = (event: MessageEvent) => {
      if (event.data?.type === "el-press-enter") {
        handleOkClick(new MouseEvent("click") as any);
      }
    };
    window.addEventListener("message", listener);
    return () => window.removeEventListener("message", listener);
  }, [handleOkClick]);

  const handleQuestionFrameLoad = useIframeEnterKey(iframeRef, () => {
    iframeRef.current?.ownerDocument.getElementById('imgOK')?.click();
  });

  const handleBack = () => {
    // Use the 'params' object already defined in your component
    const calledFrom = params.get("calledFrom");

    // console.log("calledFrom:", calledFrom);
    if (calledFrom) {
      const redirectPath = decodeURIComponent(calledFrom);
      window.location.href = redirectPath;
    }
    else if (window.history.length > 1) {
      window.history.back();
    }
  };

  return (
    <>
      {!isInAssessment && (
        <tr id="trQnButtons">
          <td className="QnPanelT">
            <table id="tabQnNav" className="QnPanel2T" style={{ height: "50px" }}>
              <tbody>
                <tr id="trQnOK" className="trQnOKT">
                  <td id="QnPanelIdT" className="QnPanel">&nbsp;</td>
                  <td id="QnPanelId2T" className="QnPanel">
                    <div
                      onClick={!okClicked ? handleBack : undefined}
                      style={{ cursor: 'pointer', display: okClicked ? 'none' : 'block' }}
                    >
                      <img
                        src={backSrc} alt="Back"
                        onMouseOver={handleBackMouseOver} onMouseOut={handleBackMouseOut}
                        onMouseDown={handleBackMouseDown} onMouseUp={handleBackMouseUp}
                      />
                    </div>
                  </td>
                  <td id="QnPanelId3T" className="QnPanel">
                    <input
                      type="image"
                      id="imgPrc"
                      src={principle_n}
                      className="imgPrcT"
                      alt="Principle"
                      style={{ display: !okClicked && currentQnMeta?.NoOfPrc && currentQnMeta.NoOfPrc > 0 ? 'block' : 'none' }}
                      onClick={(e) => { e.preventDefault(); handlePrcClick(); }}
                    />
                  </td>
                  <td id="QnPanelId4T" className="QnPanel">
                    <input
                      type="image"
                      id="imgClue"
                      src={clue_n}
                      className="imgClueT"
                      alt="Clue"
                      style={{ display: !okClicked && Number(currentQnMeta?.NoOfClues || 0) > 0 ? 'block' : 'none' }}
                      onClick={(e) => { e.preventDefault(); handleClueClick(); }}
                    />
                  </td>
                  <td id="QnPanelId5T" className="QnPanel">
                    <input
                      type="image"
                      id="imgSoln"
                      src={solutionSrc}
                      className="imgSolnT"
                      alt="Solution"
                      style={{ display: currentQnMeta?.NoOfSol && currentQnMeta.NoOfSol > 0 ? 'inline-block' : 'none' }}
                      onClick={(e) => { e.preventDefault(); handleSolnClick(false); }}
                      onMouseOver={handleSolutionMouseOver}
                      onMouseOut={handleSolutionMouseOut}
                      onMouseDown={handleSolutionMouseDown}
                    />
                  </td>
                  <td id="QnPanelId5T" className="QnPanel">
                    <a
                      href={`/STUDENT/Tutorials/Tutorial?id=${folderParam}&name=${encodeURIComponent(lessonName ?? '')}&folder=${encodeURIComponent(diccode ?? '')}&calledFrom=${encodeURIComponent(calledFrom ?? '')}&sessionId=${sessionId}&currentPage=${currentPage}`}
                      id="imgbtnTut"
                      className="imgbtnTutT"
                      style={{ display: okClicked ? 'none' : 'inline-block' }}
                    >
                      <img src={tutorials_n} alt="Tutorial" id="imgbtnTut2T" />
                    </a>
                  </td>
                  <td id="QnPanelId6T" className="QnPanel">
                    {isSubmitting ? (
                      <Loading />
                    ) : okClicked ? (
                      currentPage === totalPages ? (
                        <img
                          src={doneSrc}
                          alt="Done"
                          style={{ verticalAlign: 'middle' }}
                          onClick={() => handleDoneClick(() => {
                            const dicCode = sessionStorage.getItem('SelectedDICFile') || '';
                            const lsnTestCode = sessionStorage.getItem('LsnTestCode') || '';
                            const calledFrom = params.get("calledFrom") || "";
                            navigate(`/STUDENT/Tutorials/Result?DicCode=${dicCode}&LsnTestCode=${lsnTestCode}&SessionID=${sessionId}&source=lesson` + (calledFrom ? `&calledFrom=${encodeURIComponent(calledFrom)}` : ""));
                          })}
                          onMouseOver={() => setDoneSrc(done_o)}
                          onMouseOut={() => setDoneSrc(done_n)}
                        />
                      ) : (
                        <img
                          src={nextSrc}
                          alt="Next"
                          onClick={goToNextPage}
                          onMouseOver={handleNextMouseOver}
                          onMouseOut={handleNextMouseOut}
                          onMouseDown={handleNextMouseDown}
                          onMouseUp={handleNextMouseUp}
                          style={{ display: 'inline-block', cursor: 'pointer', marginTop: '3px' }}
                        />
                      )
                    ) : (
                      <div
                        onClick={handleOkClick}
                        onMouseOver={handleOkMouseOver}
                        onMouseOut={handleOkMouseOut}
                        onMouseDown={handleOkMouseDown}
                        onMouseUp={handleOkMouseUp}
                        style={{ display: 'inline-block', cursor: 'pointer' }}
                      >
                        <img src={okSrc} alt="OK" style={{ marginTop: '3px' }} />
                      </div>
                    )}
                  </td>
                  <td id="QnPanelId7" className="QnPanel">&nbsp;</td>
                </tr>
                <tr id="trQnNext" className="trQnNextT">
                  <td id="tdBN1" className="QnPanel">&nbsp;</td>
                  <td id="tdAnsMsg" className="QnPanel">&nbsp;</td>
                  <td id="tdShowCA" className="QnPanel">&nbsp;</td>
                  <td id="tdAnsSoln" className="QnPanel">
                    <img
                      id="imgSolnAfterAnswering"
                      src={solutionSrc}
                      alt="Solution"
                      onMouseOver={handleSolutionMouseOver}
                      onMouseOut={handleSolutionMouseOut}
                      onMouseDown={handleSolutionMouseDown}
                    />
                  </td>
                  <td id="tdQnNext" className="QnPanel">
                    {okClicked ? (
                      <input
                        type="image"
                        id="imgNextQuestion"
                        src={nextSrc}
                        alt="Next"
                        onClick={goToNextPage}
                        onMouseOver={handleNextMouseOver}
                        onMouseOut={handleNextMouseOut}
                        onMouseDown={handleNextMouseDown}
                        onMouseUp={handleNextMouseUp}
                        style={{ display: okClicked ? 'inline-block' : 'none' }}
                      />
                    ) : (
                      <img
                        id="imgOK"
                        src={okSrc}
                        alt="OK"
                        onClick={handleOkClick}
                        onMouseOver={handleOkMouseOver}
                        onMouseOut={handleOkMouseOut}
                        onMouseDown={handleOkMouseDown}
                        onMouseUp={handleOkMouseUp}
                        className="imgOKT"
                        style={{ display: okClicked ? 'none' : 'inline-block' }}
                      />
                    )}
                  </td>
                  <td id="tdBN" className="QnPanel">&nbsp;</td>
                </tr>
              </tbody>
            </table>
          </td>
        </tr>
      )}
      {questionHtml ? (
        <tr id="triFrame">
          <td id="tdFrameQnT" style={{ padding: 0, height: '100%' }}>
            <div id="divFrameQn" style={{ height: 'calc(95vh - 50px)', width: '100%', display: 'flex', flexDirection: 'column' }}>
              {questionHtml ? (
                <iframe
                  id="iFrameQn"
                  ref={iframeRef}
                  frameBorder={0}
                  scrolling="yes"
                  className="CssiFrm"
                  style={{
                    flex: '1 1 0',
                    width: '100%',
                    height: '100%',
                    minHeight: 0,
                    border: 'none',
                    overflow: 'auto'
                  }}
                  title="Question Page"
                  onLoad={() => {
                    handleQuestionFrameLoad();
                    if (!isPreview) return;

                    const iframeDoc = iframeRef.current?.contentDocument;
                    if (!iframeDoc) return;

                    try {
                      const correctAnswerEl = iframeDoc.querySelector("#KSD_MW_CA") as HTMLInputElement | null;
                      const correctAnswer = correctAnswerEl?.value.trim() || "";
                      const displayAnswer = correctAnswer.split('|')[0].split('^^')[0] || correctAnswer;

                      const userAnswerEl = iframeDoc.querySelector("#KSD_W") as HTMLTextAreaElement | null;
                      const CORRECT_URL = "https://www.elearnoncloud.com/Storage/assets/Image/Questions/EL_O/AnsCorrect.GIF";

                      // NEW — admin preview only. Fill the textbox with the correct
                      // answer, disable it, and paint the same "correct" feedback
                      // handleOkClick renders on a real right answer.
                      if (!isNumberPad && userAnswerEl) {
                        userAnswerEl.value = displayAnswer;
                        userAnswerEl.disabled = true;

                        const tdAns0 = iframeDoc.getElementById("KSD_TDANS_0");
                        if (tdAns0) {
                          tdAns0.style.display = "";
                          tdAns0.innerHTML = `<img id='imgR' src='${CORRECT_URL}' alt='Correct Answer' style='vertical-align: middle;'/>`;
                        }
                      } else {
                        if (userAnswerEl) {
                          userAnswerEl.value = displayAnswer;
                          userAnswerEl.disabled = true;
                        }
                        const tdAns0 = iframeDoc.querySelector("#KSD_TDANS_0") as HTMLElement | null;
                        if (tdAns0) {
                          tdAns0.innerHTML = `<img data-mark="1" src="${CORRECT_URL}" alt="Correct">`;
                          tdAns0.style.display = "table-cell";
                        }
                        if (iframeRef.current?.contentWindow) {
                          (iframeRef.current.contentWindow as any).insertDigit = () => { };
                        }
                      }
                    } catch (e) {
                      console.error("Error revealing preview answer:", e);
                    }

                    setOkClicked(true);
                    if (isSolutionMode) {
                      handleSolnClick(true);
                    }
                  }}
                />
              ) : <Loading />}
            </div>
          </td>
        </tr>
      ) : null}

      {questionHtml ? null : <Loading />}

      {showClueModal && (
        <>
          {!showSolnModal && <div id="divReadOnlyScreen" style={{ display: 'block' }} onClick={() => setShowClueModal(false)}></div>}
          <div id="divClue" style={{ display: 'block' }}>
            <table id="tblTitleClue" className="clue" cellSpacing="0" cellPadding="0" width="100%" style={{ height: "50px", fontSize: "15px" }}>
              <tbody>
                <tr>
                  <td id="tdClueTitle1" align="left">Clue</td>
                  <td id="tdClueClose" align="right" valign="top">
                    <img
                      id="imgClueClose"
                      src={CloseBtnSrc}
                      alt="Close"
                      onClick={() => setShowClueModal(false)}
                      onMouseOver={handleCloseBtnMouseOver}
                      onMouseOut={handleCloseBtnMouseOut}
                      style={{ cursor: 'pointer', padding: '5px' }}
                    />
                  </td>
                </tr>
              </tbody>
            </table>

            <div id="divFrameClue">
              {isClueLoading ? <Loading /> : (
                <iframe
                  id="iFrameClue"
                  ref={clueIframeRef}
                  title="Clue"
                  srcDoc={clueContent}
                  style={{ width: '100%', border: 'none', minHeight: '80px' }}
                  onLoad={() => {
                    // console.log("Clue iframe onLoad event fired.");
                    const iframe = clueIframeRef.current;
                    if (!iframe || !iframe.contentDocument || !iframe.contentWindow) { return; }
                    try {
                      const divShows = iframe.contentDocument.querySelectorAll("[id^='divShow']");
                      divShows.forEach(div => {
                        (div as HTMLElement).style.padding = "20px";
                      });
                      const cluesInput = iframe.contentDocument.getElementById('NoOfClues') as HTMLInputElement;
                      const totalClues = parseInt(cluesInput?.value || '0', 10);
                      setNoOfClues(totalClues);

                      const clueDivs = iframe.contentDocument.querySelectorAll<HTMLElement>('[id^="divShow"]');
                      clueDivs.forEach((div, index) => {
                        div.style.display = index === 0 ? 'block' : 'none';
                      });

                      const firstClueDiv = iframe.contentDocument.getElementById('divShow1');
                      if (firstClueDiv) {
                        const newHeight = firstClueDiv.scrollHeight;
                        iframe.style.height = `${Math.min(newHeight, 300)}px`;
                      } else if (totalClues === 0) {
                        iframe.style.height = '50px';
                      }
                    } catch (e) { console.error("Error inside clue iframe onLoad:", e); }
                  }}
                />
              )}
            </div>

            <table id="tblNavClue" className="clue" cellSpacing="0" cellPadding="0" width="100%" style={{ backgroundColor: '#F2F2F2' }}>
              <tbody>
                <tr>
                  <td style={{ width: '33%' }}>&nbsp;</td>
                  <td style={{ width: '34%' }}>&nbsp;</td>
                  <td align="right" style={{ width: '33%', paddingRight: '15px' }}>
                    {!isClueLoading && noOfClues > 1 && currentClueNo < noOfClues - 1 && (
                      <img
                        id="btnClueNext"
                        src={NextStepBtnSrc}
                        alt="Next Clue"
                        onClick={() => {
                          const nextClue = currentClueNo + 1;
                          const iframe = clueIframeRef.current;
                          if (iframe?.contentDocument) {
                            iframe.contentDocument.querySelectorAll<HTMLElement>('[id^="divShow"]').forEach((div, index) => {
                              div.style.display = index === nextClue ? 'block' : 'none';
                            });
                            setCurrentClueNo(nextClue);
                            const nextClueDiv = iframe.contentDocument.getElementById(`divShow${nextClue + 1}`);
                            if (nextClueDiv) {
                              const newHeight = nextClueDiv.scrollHeight + 20;
                              iframe.style.height = `${Math.min(newHeight, 300)}px`;
                            }
                          }
                        }}
                        onMouseOver={handleNextStepBtnMouseOver}
                        onMouseOut={handleNextStepBtnMouseOut}
                        style={{ cursor: 'pointer' }}
                      />
                    )}
                    {!isClueLoading && (noOfClues <= 1 || currentClueNo === noOfClues - 1) && (
                      <img
                        id="btnClueGotIt"
                        src={GotItBtnSrc}
                        alt="Got It"
                        onClick={() => setShowClueModal(false)}
                        onMouseOver={handleGotItBtnMouseOver}
                        onMouseOut={handleGotItBtnMouseOut}
                        style={{ cursor: 'pointer', display: isClueLoading ? 'none' : 'inline-block' }}
                      />
                    )}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </>
      )}

      {showPrcModal && (
        <>
          <div id="divReadOnlyScreen" style={{ display: 'block' }} onClick={() => setShowPrcModal(false)}></div>

          <div id="divPCS" style={{ display: 'block' }} className="principle">

            {/* Header */}
            <table id="tblTitlePCS" className="principle" cellSpacing="0" cellPadding="0" width="100%">
              <tbody>
                <tr>
                  <td id="tdPCSTitle1" style={{ paddingLeft: '15px', color: 'white', fontWeight: 'bold', fontSize: '24px' }}>
                    Principle {principleList.length > 1 ? ` ${currentPrcIndex + 1} of ${principleList.length}` : ''}
                  </td>
                  <td id="tdPCSClose" align="right" valign="top">
                    <img
                      id="imgPCSClose"
                      src={CloseBtnSrc}
                      alt="Close"
                      onClick={() => { setShowPrcModal(false); setIsPrcLoading(false); }}
                      onMouseOver={handleCloseBtnMouseOver}
                      onMouseOut={handleCloseBtnMouseOut}
                      style={{ cursor: 'pointer', padding: '5px', width: '40px', height: '40px', marginRight: '30px' }}
                    />
                  </td>
                </tr>
              </tbody>
            </table>

            {/* Body */}
            <div id="divFramePCS">
              {isPrcLoading ? <Loading /> : (
                <iframe
                  id="iFramePrc"
                  ref={prcIframeRef}
                  title="Prc"
                  srcDoc={prcContent}
                  style={{ width: '100%', border: 'none', overflow: 'hidden', display: 'block' }} // 2. Set overflow hidden initially
                  onLoad={() => {
                    const iframe = prcIframeRef.current;
                    if (!iframe || !iframe.contentDocument || !iframe.contentWindow) return;

                    setTimeout(() => {
                      if (!iframe.contentDocument || !iframe.contentDocument.body) return;

                      const contentHeight = iframe.contentDocument.body.scrollHeight + 20;

                      const divPCS = document.getElementById('divPCS') as HTMLElement;
                      const titleTable = document.getElementById('tblTitlePCS') as HTMLElement;
                      const navTable = document.getElementById('tblNavPCS') as HTMLElement;
                      if (divPCS && titleTable && navTable) {
                        const maxModalHeight = window.innerHeight * 0.8;
                        const maxIframeHeight = maxModalHeight - titleTable.offsetHeight - navTable.offsetHeight;
                        if (contentHeight > maxIframeHeight) {

                          iframe.style.height = `${maxIframeHeight}px`;
                          iframe.style.overflowY = 'auto';
                        } else {

                          iframe.style.height = `${Math.max(contentHeight, 80)}px`;
                          iframe.style.overflowY = 'hidden';
                        }
                      } else {
                        iframe.style.height = `${Math.max(contentHeight, 80)}px`;
                      }
                    }, 50);
                  }}
                />
              )}
            </div>

            {/* Footer / Navigation */}
            <table id="tblNavPCS" className="principle" cellSpacing="0" cellPadding="0" width="100%" style={{ height: '50px' }}>
              <tbody>
                <tr style={{ backgroundColor: '#F2F2F2' }}>
                  {/* Previous Button */}
                  <td align="left" style={{ width: '33%', paddingLeft: '15px' }}>
                    {currentPrcIndex > 0 && (
                      <input
                        type='button'
                        value='PREVIOUS'
                        onClick={() => {
                          const prevIndex = currentPrcIndex - 1;
                          setCurrentPrcIndex(prevIndex);
                          const folderParam = new URLSearchParams(window.location.search).get('folder') || '';
                          const countryParam = params.get('country') || 'Australia';
                          fetchPrincipleContent(principleList[prevIndex], folderParam, countryParam).then(data => setPrcContent(data.principleHtml || ""));
                        }}
                        style={{
                          fontWeight: 'bold',
                          color: 'White',
                          fontSize: '12pt',
                          borderStyle: 'none',
                          backgroundColor: 'maroon',
                          cursor: 'pointer',
                          padding: '5px 10px'
                        }}
                      />
                    )}
                  </td>

                  <td style={{ width: '34%' }}>&nbsp;</td>

                  {/* Next / Got It Button */}
                  <td align="right" style={{ width: '33%', paddingRight: '15px' }}>
                    {currentPrcIndex < principleList.length - 1 ? (
                      <img
                        src={NextStepBtnSrc}
                        alt="Next"
                        onClick={() => {
                          const nextIndex = currentPrcIndex + 1;
                          setCurrentPrcIndex(nextIndex);
                          const folderParam = new URLSearchParams(window.location.search).get('folder') || '';
                          const countryParam = params.get('country') || 'Australia';
                          fetchPrincipleContent(principleList[nextIndex], folderParam, countryParam).then(data => setPrcContent(data.principleHtml || ""));
                        }}
                        onMouseOver={handleNextStepBtnMouseOver}
                        onMouseOut={handleNextStepBtnMouseOut}
                        style={{ cursor: 'pointer', width: '100px', height: '40px', marginRight: '30px', marginTop: '5px', marginBottom: '5px' }}
                      />
                    ) : (
                      <img
                        src={GotItBtnSrc}
                        id="imgGotIt"
                        alt="Got It"
                        onClick={() => { setShowPrcModal(false); setIsPrcLoading(false); }}
                        onMouseOver={handleGotItBtnMouseOver}
                        onMouseOut={handleGotItBtnMouseOut}
                        style={{ cursor: 'pointer', width: '100px', height: '40px', marginRight: '30px', marginTop: '5px', marginBottom: '5px' }}
                      />
                    )}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </>
      )}

      {showSolnModal && (
        <>
          <div id="divReadOnlyScreen" style={{ display: 'block' }} onClick={() => {
            setShowSolnModal(false);
            setCurrentSolnNo(0);
          }}></div>
          <div id="divPCS" style={{ display: 'block', position: 'fixed', bottom: '0', width: '100%', zIndex: 10000 }}>
            <table id="tblTitlePCS" className="solution" cellSpacing="0" cellPadding="0" width="100%">
              <tbody>
                <tr>
                  <td id="tdPCSTitle1">Step by step solution</td>
                  <td id="tdPCSClose" align="right" valign="top">
                    <img
                      id="imgPCSClose"
                      src={CloseBtnSrc}
                      alt="Close"
                      onClick={() => {
                        setShowSolnModal(false);
                        setCurrentSolnNo(0);
                      }}
                      onMouseOver={handleCloseBtnMouseOver}
                      onMouseOut={handleCloseBtnMouseOut}
                      style={{ cursor: 'pointer', padding: '5px' }}
                    />
                  </td>
                </tr>
              </tbody>
            </table>
            <div id="divFramePCS">
              {isSolnLoading ? <Loading /> : (
                <iframe
                  id="iFrameSolution"
                  ref={solnIframeRef}
                  title="Solution"
                  srcDoc={solnContent}
                  style={{ width: '100%', border: 'none', minHeight: '50px' }}
                  onLoad={() => {
                    const iframe = solnIframeRef.current;
                    if (!iframe || !iframe.contentDocument || !iframe.contentWindow) {
                      console.error("Iframe document or window not ready in onLoad.");
                      return;
                    }
                    try {
                      const iframeDoc = iframe.contentDocument;
                      const style = iframeDoc.createElement('style');
                      style.textContent = `
                                                tr[id^="trSolStepLHS"] td {
                                                    width: 50% !important;
                                                    box-sizing: border-box !important;
                                                }

                                                table[id^="tblSol"] tr td:first-child {
                                                    width: 50% !important;
                                                }

                                                table[id^="tblSol"] tr td:nth-child(2) {
                                                    width: 50% !important;
                                                }
                                            `;
                      if (iframeDoc.head) {
                        iframeDoc.head.appendChild(style);
                      }
                      const stepsInput = iframeDoc.getElementById('NoOfSteps') as HTMLInputElement;
                      const totalSteps = parseInt(stepsInput?.value || '0', 10);
                      setNoOfSteps(totalSteps);

                      const isAutoExpanded = iframeDoc.getElementById('IsAutoExpanded');

                      const stepRows = iframeDoc.querySelectorAll<HTMLElement>('[id^="trSolStepLHS"]');

                      stepRows.forEach((step, index) => {
                        if (index === 0 || isAutoExpanded) {
                          step.style.display = 'table-row';
                        } else {
                          step.style.display = 'none';
                        }
                      });

                      if (totalSteps === 0) {
                        iframe.style.height = '50px';
                      }

                      setTimeout(() => {
                        if (!iframe.contentDocument || !iframe.contentDocument.body) return;

                        const contentHeight = iframe.contentDocument.body.scrollHeight + 5;

                        const divPCS = document.getElementById('divPCS') as HTMLElement;
                        const titleTable = document.getElementById('tblTitlePCS') as HTMLElement;
                        const navTable = document.getElementById('tblNavPCS') as HTMLElement;

                        if (divPCS && titleTable && navTable) {
                          const maxModalHeight = window.innerHeight * 0.45;
                          const maxIframeHeight = maxModalHeight - titleTable.offsetHeight - navTable.offsetHeight;

                          if (contentHeight > maxIframeHeight) {
                            iframe.style.height = `${maxIframeHeight}px`;
                            iframe.style.overflowY = 'auto';
                          } else {
                            iframe.style.height = `${Math.max(contentHeight, 50)}px`;
                            iframe.style.overflowY = 'hidden';
                          }
                        }

                        if (isAutoExpanded) {
                          setCurrentSolnNo(totalSteps - 1);
                          if (solutionSeen !== 'Y') {
                            setSolutionSeen('Y');
                          }
                          iframe.contentWindow?.scrollTo(0, iframe.contentDocument.body.scrollHeight);
                        }
                      }, 50);

                      iframeDoc.querySelectorAll<HTMLImageElement>('img[id^="KsdImg"]').forEach(img => {
                        img.onclick = () => {
                          const index = img.id.substring(6);
                          const ksdDiv = iframeDoc.getElementById(`KsdDiv${index}`);
                          const content = ksdDiv?.getAttribute('data-ksd-content');
                          const parentTd = img.closest('td');
                          if (content && parentTd && img.getAttribute('alt') === '1') {
                            parentTd.innerHTML = content;
                            img.setAttribute('alt', '2');
                          }
                        };
                      });

                    } catch (e) {
                      console.error("Error inside solution iframe onLoad:", e);
                    }
                  }}
                />
              )}
            </div>
            <table id="tblNavPCS" className="solution" cellSpacing="0" cellPadding="0" width="100%" style={{ backgroundColor: '#F2F2F2' }}>
              <tbody>
                <tr>
                  <td align="left" style={{ width: '33%', paddingLeft: '15px' }}></td>
                  <td style={{ width: '34%' }}>&nbsp;</td>
                  <td align="right" style={{ width: '33%', paddingRight: '15px' }}>
                    {!isSolnLoading && noOfSteps > 0 && currentSolnNo < noOfSteps - 1 && (
                      <img
                        id="btnPCSNext"
                        src={NextStepBtnSrc}
                        alt="Next Step"
                        onClick={() => {
                          const nextStep = currentSolnNo + 1;
                          const iframe = solnIframeRef.current;

                          if (iframe?.contentDocument?.body) {
                            const iframeDoc = iframe.contentDocument;

                            const stepRows = iframeDoc.querySelectorAll<HTMLElement>('[id^="trSolStepLHS"]');
                            if (nextStep >= stepRows.length) return;

                            const nextStepElement = stepRows[nextStep];
                            nextStepElement.style.display = 'table-row';

                            setTimeout(() => {
                              if (!iframe.contentDocument || !iframe.contentDocument.body) return;

                              const totalRequiredHeight = iframe.contentDocument.body.scrollHeight + 5;

                              const divPCS = document.getElementById('divPCS') as HTMLElement;
                              const titleTable = document.getElementById('tblTitlePCS') as HTMLElement;
                              const navTable = document.getElementById('tblNavPCS') as HTMLElement;

                              if (!divPCS || !titleTable || !navTable) return;

                              const maxModalHeight = window.innerHeight * 0.45;
                              const chromeHeight = titleTable.offsetHeight + navTable.offsetHeight;
                              const maxAllowedIframeHeight = maxModalHeight - chromeHeight;

                              if (totalRequiredHeight > maxAllowedIframeHeight) {
                                iframe.style.height = `${maxAllowedIframeHeight}px`;
                                iframe.style.overflowY = 'auto';
                              } else {
                                iframe.style.height = `${totalRequiredHeight}px`;
                                iframe.style.overflowY = 'hidden';
                              }

                              iframe.contentWindow?.scrollTo(0, iframe.contentDocument.body.scrollHeight);

                            }, 50);

                            setCurrentSolnNo(nextStep);
                            if (solutionSeen !== 'Y') {
                              setSolutionSeen(nextStep + 1);
                            }
                          }
                        }}
                        onMouseOver={handleNextStepBtnMouseOver}
                        onMouseOut={handleNextStepBtnMouseOut}
                        style={{ cursor: 'pointer' }}
                      />
                    )}
                    {!isSolnLoading && (noOfSteps === 0 || currentSolnNo === noOfSteps - 1) && (
                      <img
                        id="btnPCSClose"
                        src={GotItBtnSrc}
                        alt="Got It"
                        onClick={() => {
                          setShowSolnModal(false);
                          setCurrentSolnNo(0);
                          setSolutionSeen('Y');
                        }}
                        onMouseOver={handleGotItBtnMouseOver}
                        onMouseOut={handleGotItBtnMouseOut}
                        style={{ cursor: 'pointer', display: isSolnLoading ? 'none' : 'inline-block' }}
                      />
                    )}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </>
      )}
    </>
  );
};

export default forwardRef(WQns);
